import { Input, InputProps } from '@/app/components/Input'
import { SearchBackground } from '@/app/icons/SearchBackground'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import { MdTune } from 'react-icons/md'

type TextSearchInputProps = InputProps & {
  onSearch: (searchTerm: string) => void
  defaultValue?: string
  noIcon?: boolean
  onFilterClick?: (term: string) => void
  hideFilters?: boolean
}

export const TextSearchInput = ({
  onSearch,
  defaultValue = '',
  noIcon = false,
  onFilterClick,
  hideFilters = false,
  ...props
}: TextSearchInputProps) => {
  const [term, setTerm] = useState(defaultValue)
  const t = useTranslations('header')

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      const value = e.currentTarget.value.trim()
      if (value) {
        onSearch(value)
      }
    }
  }

  const handleIconClick = () => {
    if (term && term.trim()) {
      onSearch(term.trim())
    }
  }

  return (
    <Input
      {...props}
      type="text"
      value={term}
      onChange={(e) => setTerm(e.target.value)}
      onKeyDown={handleKeyDown}
      placeholder={t('text_search_placeholder')}
      className={`!max-h-[50px] !rounded-[10px] !py-[6px] !pl-2 !pr-[6px] text-sm focus-within:outline-mydra-black md:!rounded-xl md:!py-[9px] md:!pl-6 md:!pr-2 md:text-base ${props.className ?? ''}`}
      endDecoration={
        !noIcon ? (
          <div className="flex items-center justify-center gap-1 md:gap-2">
            {!hideFilters && (
              <button
                onClick={() => onFilterClick?.(term)}
                className="flex items-center gap-1"
              >
                <MdTune className="size-6 md:size-5" />
                <span className="hidden text-sm md:inline">{t('filters')}</span>
              </button>
            )}
            <button onClick={handleIconClick}>
              <SearchBackground width={33} height={33} className="md:hidden" />
              <SearchBackground
                width={40}
                height={40}
                className="hidden md:block"
              />
            </button>
          </div>
        ) : null
      }
    />
  )
}
